export enum StoreAccountPlanType {
  Dokan = 110, //دکان
  Laboratory = 120, //آزمایشگاه
  Plough = 130, //خیش
  Nasagh = 140, //نسق
  Boneh = 150, //بنه
  NoStore = 0,
}
